// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"c9f40f0e","951":"0984eb34"}[chunkId] + ".chunk.css";
};